import { environment } from '../../environments/environment';

export const BASEURL = environment.apiUrl;
export const LOGIN = BASEURL + 'auth/local';
export const URL = environment.baseUrl;
